import { render, staticRenderFns } from "./PositionAdd.vue?vue&type=template&id=5d99ff2f&"
import script from "./PositionAdd.vue?vue&type=script&lang=js&"
export * from "./PositionAdd.vue?vue&type=script&lang=js&"
import style0 from "./PositionAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports